import React, { useState, useContext } from 'react';
import axios from 'axios';
import { Box, Flex, Card } from '../design-system';
import styled from 'styled-components';
import { TableCardHeader } from './Table';
import { required } from '../helpers/utils';
import Alert from '../helpers/alert';
import { successRefetch } from '../helpers/data-loader';
import { Session } from '../contexts/sessionContext';
import ModalForm from './ModalForm';
import { ERR_MSG } from '../globalConstants';

const Image = styled.img`
  width: 100%;
  height: auto;
`;

interface ClientLogoProps {
  clientId?: any;
  isOpen: boolean;
  onClick: () => void;
  onClose: () => void;
  canEdit?: boolean;
  refetch: () => void;
  logo?: { path: string; filename: string } | null;
}

const ClientLogo = ({
  clientId,
  isOpen,
  onClick,
  onClose,
  canEdit,
  refetch,
  logo,
}: ClientLogoProps) => {
  const {
    state: {
      user: { agency_id },
    },
  } = useContext(Session);
  const [logoFile, setLogoFile] = useState<any>(null);
  const LOGO_FIELDS = [
    {
      name: 'file',
      label: 'Choose a logo',
      validate: required,
      type: 'file',
      fileOnChange: (val) => setLogoFile(val),
    },
  ];

  const handleSubmit = async () => {
    if (clientId) {
      // every logo must have a clientId
      const newFile = new FormData();
      newFile.append('client_id', clientId);
      newFile.append('agency_id', agency_id);
      newFile.append('file', logoFile);
      newFile.append('model_type', `AppModelsLogo`);
      newFile.append('model_id', clientId);
      try {
        await axios.post('/logo', newFile);
        await successRefetch(refetch);
        onClose();
      } catch (error) {
        Alert.error(ERR_MSG);
      }
    }
  };

  return (
    <Card>
      <TableCardHeader
        name={logo ? 'Logo' : null}
        action={logo ? 'Change Logo' : 'Add Logo'}
        onClick={onClick}
        disabled={!canEdit}
      />
      {logo && (
        <Flex mb={2}>
          <Box maxWidth={200}>
            <Image src={`${logo.path}`} alt={`${logo.filename}`} />
          </Box>
        </Flex>
      )}
      <ModalForm
        isOpen={isOpen}
        title={logo ? 'Change Logo' : 'Add Logo'}
        onSubmit={handleSubmit}
        onClose={onClose}
        fields={LOGO_FIELDS}
        oneColumn
      />
    </Card>
  );
};

export default ClientLogo;
